module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CL-1ccd5df7c7a68a655a7b9d8b2ab1f58e.png";